module.exports = __webpack_public_path__ + "img/popup-header-address.73d02f60.png";